/**
 *  This function open new centered window with url to share
 * @param {String} socialNetworkUrl url of the social network to share containing the url of the article
 * @param {String} title The title of the window eg : "partager sur twitter"
 * @param {Number} widthPopup The width of the popup(optional)
 * @param {Number} heightPopup The height of the popup(optional)
 * @returns true
 */
const centerPopup = (socialNetworkUrl, title, widthPopup, heightPopup) => {
  //get window positions
  const windowLeft = window.screenLeft || window.screenX;
  const windowTop = window.screenTop || window.screenY;

  //get the window size
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  //popup size
  const popupWidth = widthPopup || 620;
  const popupHeight = heightPopup || 400;

  //popup position
  const popupLeft = windowLeft + windowWidth / 2 - popupWidth / 2;
  const popupTop = windowTop + windowHeight / 2 - popupHeight / 2;

  //open a window popup
  const popup = window.open(
    socialNetworkUrl,
    title,
    `scrollbars=yes,resizable=yes,width=${popupWidth},height=${popupHeight}, top=${popupTop}, left=${popupLeft}`
  );

  //make popup focusable
  popup.focus();
  return true;
};

const shareOnFacebook = (e, urlOfArticleToShare) => {
  e.preventDefault();

  //custum shared url
  const url =
    "https://www.facebook.com/sharer/sharer.php?u=" +
    encodeURIComponent(urlOfArticleToShare);

  centerPopup(url, "Partager sur Facebook");
};

const shareOnLinkedIn = (e, urlOfArticleToShare) => {
  e.preventDefault();

  //custum shared url
  const url =
    "https://www.linkedin.com/shareArticle?mini=true&url=" +
    encodeURIComponent(urlOfArticleToShare);

  centerPopup(url, "Partager sur LinkedIn");
};

const shareOnInstagram = (e, urlOfArticleToShare) => {
  e.preventDefault();

  //custum shared url
  const url = "https://www.instagram.com/p/";

  centerPopup(url, "Partager sur Instagram");
};

const shareOnWhatsapp = (e, urlOfArticleToShare) => {
  e.preventDefault();

  console.log(window.location.href);

  //custum shared url
  const url =
    "https://api.whatsapp.com/send?text=" +
    encodeURIComponent(urlOfArticleToShare);

  centerPopup(url, "Partager sur Whatsapp");
};

const shareOnTwitter = (e, urlOfArticleToShare, articleName) => {
  e.preventDefault();

  console.log(document.title);

  //custum shared url
  const url =
    "https://twitter.com/intent/tweet?text=" +
    "Visite cet article de qualité à prix raisonnable : " +
    encodeURIComponent(articleName) +
    "&url=" +
    encodeURIComponent(urlOfArticleToShare);

  // pour tager une personne, il suffit de rajouter "&via=NomDeLaPersonne"

  centerPopup(url, "Partager sur Twitter");
};

const shareOnTiktok = (e, urlOfArticleToShare) => {
  e.preventDefault();

  //custum shared url
  const url =
    "https://www.tiktok.com/share/?url=" +
    encodeURIComponent(urlOfArticleToShare);

  centerPopup(url, "Partager sur Tiktok");
};

export {
  shareOnFacebook,
  shareOnLinkedIn,
  shareOnInstagram,
  shareOnWhatsapp,
  shareOnTwitter,
  shareOnTiktok,
};
